module.exports = __webpack_public_path__ + "img/card1_new_m.65012e64.svg";